export default __webpack_public_path__ + "static/media/sana2.a75e3500.jpg";